<div class="border-solid !box-border border-gray-100 !max-w-full">
  <dsr-header [projectName]="'ASOS'" [logoSrc]="'assets/images/rg-brand.svg'" class="!flex !items-center !box-border">

    <!-- Header left content  -->
    <ng-container dsrLeftHeaderContent>
      <a routerLink="/home" aria-label="Home - Renault ASOS">
        <div class="flex gap-[2rem] items-center !h-full">
          <img src="assets/images/rg-brand.svg" class="sm:size-[5.2rem] size-[6.2rem]" alt="Renault Group logo" />
          <h1 class="!font-renault-group-semi-bold dsr-typescale-title-small">ASOS</h1>
        </div>
      </a>
    </ng-container>

    <!-- Header middle content -->
    <!-- desktop navigation -->
    <ng-container dsrMidHeaderContent>
      <nav class="h-[6.4rem] mxl:flex flex-col justify-end hidden" role="navigation" aria-label="Main navigation">
        <div class="flex flex-row gap-6 2xl:gap-16 items-center !h-full">
          <app-nav-menu-item link="/offers/documentation" color="{{ getThemeMode() == 'light' ? 'black' : 'white' }}"
            [title]="'HOME_PAGE_TAB1' | translate" icon="file-car" class="h-full" />
          <app-nav-menu-item link="/offers/diagnostic" color="{{ getThemeMode() == 'light' ? 'black' : 'white' }}"
            [title]="'HOME_PAGE_TAB2' | translate" icon="garage-elevator" class="h-full" />
          <app-nav-menu-item link="/offers/assistance" color="{{ getThemeMode() == 'light' ? 'black' : 'white' }}"
            [title]="'PRESENTATION_TAB5_HEADERTEXT' | translate" icon="assistance-technical" class="h-full" />
          <app-nav-menu-item link="/faq" color="{{ getThemeMode() == 'light' ? 'black' : 'white' }}" title="FAQ" icon=""
            class="h-full" width="w-[2.8rem]" />

          <div class="!h-full flex items-center">
            <app-language-menu></app-language-menu>
          </div>

          <!-- happi plugin desktop -->
          <button class="cursor-pointer" type="button" aria-label="Provide feedback" 
            [ngClass]="isAuthenticated() ? '!block' : '!hidden'">
            <svg alt="Feedback icon"
              class="!size-[2.4rem] hover:!text-[var(--dsr-color-primary)] !text-[var(--dsr-color-primary-fixed-dim)]"
              role="img" aria-label="Feedback icon" id="happi-feedback" width="24" height="24" viewBox="0 0 26 26"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor"
                d="M13.1895 0.00292969C13.1956 0.00307994 13.2018 0.00374726 13.208 0.00390625C21.1047 0.0895007 26 5.05088 26 13C25.9999 21.0186 21.0186 25.9999 13 26C4.98131 26 5.17608e-05 21.0187 0 13V12.8711C1.7393e-06 12.5379 0.0122441 12.2077 0.0371094 11.8809C0.461532 4.86935 4.90843 0.437799 11.9326 0.0332031C12.0384 0.0255819 12.1445 0.0196986 12.251 0.0146484C12.2549 0.0144925 12.2588 0.0138254 12.2627 0.0136719C12.4643 0.00428936 12.6672 1.06465e-06 12.8711 0H13C13.0633 4.08937e-07 13.1265 0.0023085 13.1895 0.00292969ZM16.7246 14.7793C16.4606 15.0596 14.9446 16.6679 13 16.668C10.8791 16.6679 9.24259 14.7538 9.22852 14.7373L8.03223 15.7158C8.03428 15.7182 8.03711 15.722 8.04102 15.7266C8.21774 15.9324 10.1983 18.2382 13 18.2383C15.9214 18.2382 17.9036 15.8124 17.9619 15.709L16.7646 14.7373C16.7642 14.7378 16.7493 14.7531 16.7246 14.7793ZM9.33203 7.33691C8.23021 7.33691 7.33691 8.23021 7.33691 9.33203C7.33715 10.4337 8.23035 11.3271 9.33203 11.3271C10.4336 11.327 11.3269 10.4336 11.3271 9.33203C11.3271 8.2303 10.4337 7.33707 9.33203 7.33691ZM16.668 7.33691C15.5663 7.33715 14.6738 8.23035 14.6738 9.33203C14.6741 10.4335 15.5665 11.3269 16.668 11.3271C17.7696 11.3271 18.6629 10.4336 18.6631 9.33203C18.6631 8.23024 17.7697 7.33697 16.668 7.33691Z" />
            </svg>
          </button>
        </div>
      </nav>
    </ng-container>

    <!-- Header right content -->
    <ng-container dsrRightHeaderContent>
      <!-- Desktop - complete Menu (visible à partir de sm) -->
      <div class="hidden mxl:flex gap-[4.9rem] items-center !my-auto justify-self-center h-full">
        <!-- buttons for authentication -->
        @if(!isAuthenticated()) {
          <div>
            <div class="flex gap-4 items-center justify-center  !h-[4.8rem]">
              <button class=" " mat-flat-button (click)="openLoginPopup()" type="button"
                aria-label="Log in to your account">
                <span class="">{{ "LOGIN_HEADER_TITLE" | translate }}</span>
              </button>
              <button mat-stroked-button color="primary" routerLink="/registration" type="button"
                aria-label="Sign up for a new account" class="">
                <span class="">{{ "SIGN_UP_BUTTON" | translate }}</span>
              </button>
            </div>
          </div>
        } @else {
            <div class="user-menu-trigger">
              <button class="flex items-center gap-[1.6rem] cursor-pointer" [matMenuTriggerFor]="userMenuPanel"
                (menuOpened)="isUserMenuOpen = true" (menuClosed)="isUserMenuOpen = false" type="button"
                aria-label="User menu" [attr.aria-expanded]="isUserMenuOpen" aria-haspopup="true"
                aria-controls="user-menu-dropdown">
                <div class="flex gap-6 items-center">
                  <span>{{ userDetails.firstName }} {{ userDetails.lastName }}</span>
                  <div class="w-fit cursor-pointer transition-transform duration-300"
                    [ngClass]="{ 'rotate-180': isUserMenuOpen }" aria-hidden="true">
                    <dsr-icon name="arrow-down-2" size="1.6rem"
                      [color]="getThemeMode() == 'light' ? 'black' : 'white'"></dsr-icon>
                  </div>
                </div>
              </button>
              <mat-menu #userMenuPanel="matMenu" xPosition="before" yPosition="below" id="user-menu-dropdown">
                <div class="w-[25rem] items-start flex border-gray-200 dark:border-gray-700 border-b-2 pb-[1.6rem] gap-[1rem]">
                  @if(userAccessCheck) {
                    <div class="font-[400] pl-[1.2rem] flex flex-col items-center gap-[0.1rem] w-full">
                      <div class="text-[1.6rem] !w-full flex gap-[0.8rem] items-center">
                        <div class="size-[1.6rem]">
                          <dsr-icon name="sales" size="1.6rem" [color]="getThemeMode() == 'light' ? 'black' : 'white'">
                          </dsr-icon>
                        </div>
                        <div>
                          <span>{{ "HEADER_LIST_MY_BALANCE" | translate }}</span>
                        </div>
                      </div>
                      <div class="pl-[2.4rem] text-[1.4rem]">
                        <span class="inline-block">{{ "HEADER_LIST_MY_ASSISTANCE_TOKENS" | translate }} :
                          <b>{{ userDetails.ticketBal }}</b></span>
                        <span class="inline-block">{{ "HEADER_LIST_MY_EURO_TOKENS" | translate }} :
                          <b>{{ userDetails.tokenBal }}</b></span>
                      </div>
                    </div>
                  }
                </div>
                @for (item of menuItemLabels; track item; let i = $index) {
                  <button mat-menu-item class="" [routerLink]="routeLinks[i]" type="button"
                    [attr.aria-label]="item | translate">
                    <div class="!w-full h-[3.8rem] items-center flex justify-between ">
                      <div class="text-[1.6rem] flex gap-[0.8rem] items-center">
                        <dsr-icon [name]="menuItemIcons[i]" size="1.6rem"
                          [color]="getThemeMode() == 'light' ? 'black' : 'white'">
                        </dsr-icon>
                        <div>
                          <span>{{ item | translate }}</span>
                        </div>
                      </div>
                      <dsr-icon name="arrow-right-2" size="2.4rem" [color]="getThemeMode() == 'light' ? 'black' : 'white'">
                      </dsr-icon>
                    </div>
                  </button>
                }
                <button mat-menu-item class="" (click)="logout()" type="button" aria-label="Log out">
                  <div class="w-full h-[3.8rem] items-center text-[1.6rem] flex gap-[1rem] ">
                    <dsr-icon name="exit" size="2.4rem" [color]="getThemeMode() == 'light' ? 'black' : 'white'">
                    </dsr-icon>
                    <div>
                      <span>{{ "HEADER_LIST_LOGOUT" | translate }}</span>
                    </div>
                  </div>
                </button>
              </mat-menu>
            </div>
        }

        <button class="!size-[2.4rem] cursor-pointer" (click)="toggleAccessibilityMenu()" type="button"
          aria-label="Toggle accessibility menu" aria-controls="accessibility-menu">
          <img src="assets/images/accessibility-logo.svg" alt="Accessibility settings icon" role="img" />
        </button>

      </div>

      <!-- Mobile - Menu burger (visible uniquement en dessous de sm) -->
      <div class="mxl:hidden flex items-center h-full gap-[3.5rem]">
        <app-language-menu triggerSize="2.5rem" itemFlagSize="2.4rem" displayProperty="code"
          [uppercase]="true"></app-language-menu>
        <button (click)="toggleMobileMenu()"
          class="mobile-menu-button flex flex-col justify-center items-center w-[4.8rem] h-[4.8rem] relative focus:outline-none"
          [attr.aria-label]="'Menu'" [attr.aria-expanded]="isMobileMenuOpen">
          <!-- Lignes du burger -->
          <span class="block w-[4.4rem] h-[0.3rem] bg-current transition-all duration-300 transform origin-center"
            [ngClass]="{'rotate-45 translate-y-[100%]': isMobileMenuOpen, 'mb-[0.8rem]': !isMobileMenuOpen}"></span>
          <span class="block w-[4.4rem] h-[0.3rem] bg-current transition-all duration-300"
            [ngClass]="{'opacity-0': isMobileMenuOpen, 'mb-[0.8rem]': !isMobileMenuOpen}"></span>
          <span class="block w-[4.4rem] h-[0.3rem] bg-current transition-all duration-300 transform origin-center"
            [ngClass]="{'-rotate-45 -translate-y-[100%]': isMobileMenuOpen}"></span>
        </button>
      </div>
    </ng-container>

  </dsr-header>

  <!-- Menu mobile déroulant -->
  <div class="mxl:hidden relative z-[9999]">
    @if(isMobileMenuOpen) {
      <div class="mobile-menu-container fixed top-[var(--dsr-comp-header-height)] left-0 right-0 bg-white shadow-lg border-t border-gray-100 z-50 transition-all duration-300 max-h-[calc(100vh-var(--dsr-comp-header-height))] overflow-y-auto">
        <!-- Mobile nav bar -->
        <div class="px-[2rem] py-[1.6rem] border-b border-gray-100">
          <div class="flex flex-col gap-[1.6rem]">
            <a routerLink="/offers/documentation" (click)="closeMobileMenu()"
              class="flex items-center justify-center gap-[1.2rem] dsr-typescale-title-medium py-[1.2rem] text-center">
              <dsr-icon name="file-car" size="2.4rem" color="black"></dsr-icon>
              {{ "HOME_PAGE_TAB1" | translate }}
            </a>
            <a routerLink="/offers/diagnostic" (click)="closeMobileMenu()"
              class="flex items-center justify-center gap-[1.2rem] dsr-typescale-title-medium py-[1.2rem] text-center">
              <dsr-icon name="garage-elevator" size="2.4rem" color="black"></dsr-icon>
              {{ "HOME_PAGE_TAB2" | translate }}
            </a>
            <a routerLink="/offers/assistance" (click)="closeMobileMenu()"
              class="flex items-center justify-center gap-[1.2rem] dsr-typescale-title-medium py-[1.2rem] text-center">
              <dsr-icon name="assistance-technical" size="2.4rem" color="black"></dsr-icon>
              {{ "PRESENTATION_TAB5_HEADERTEXT" | translate }}
            </a>
            <a routerLink="/faq" (click)="closeMobileMenu()"
              class="flex items-center justify-center dsr-typescale-title-medium py-[1.2rem] text-center">
              FAQ
            </a>
          </div>
        </div>

        <!-- token balance view in mobile -->
        @if(isAuthenticated()) {
          <div class="px-[2rem] py-[1.6rem] border-b border-gray-100">
            <div class="dsr-typescale-body-medium flex flex-col gap-[1.8rem] w-full justify-around items-center">
              <div class="flex gap-[1rem] -ml-[3rem] w-fit">
                <dsr-icon name="sales" size="2.6rem" color="black"></dsr-icon>
                <span class="inline-block">{{ "HEADER_LIST_MY_ASSISTANCE_TOKENS" | translate }} :
                  <b>{{ userDetails?.ticketBal }}</b></span>
              </div>
              <div class="w-fit">
                <span class="inline-block">{{ "HEADER_LIST_MY_EURO_TOKENS" | translate }} :
                  <b>{{ userDetails?.tokenBal }}</b></span>
              </div>
            </div>
          </div>
        }
        <!-- Auth buttons in mobile view -->
        <div class="">
          @if(!isAuthenticated()) {
            <div class="px-[2rem] py-[1.6rem]">
              <div class="flex flex-col gap-[1.2rem]">
                <button mat-flat-button class="" (click)="openLoginPopup(); closeMobileMenu()">
                  {{ "LOGIN_HEADER_TITLE" | translate }}
                </button>
                <button mat-stroked-button color="primary" routerLink="/registration" class="" (click)="closeMobileMenu()">
                  {{ "SIGN_UP_BUTTON" | translate }}
                </button>
              </div>
            </div>
          } @else {
            <div class="flex flex-col h-full bg-light-dsr-color-secondary-container">
              <!-- Ligne utilisateur cliquable -->
              <div (click)="toggleUserSubMenu()"
                class="flex items-center justify-center relative py-[1.2rem] cursor-pointer">
                <div class="flex items-center justify-center w-full gap-[1.2rem]">
                  <dsr-icon name="user" size="2.4rem" color="black"></dsr-icon>
                  <span class="dsr-typescale-body-medium !text-wrap !text-center w-fit">{{ userDetails.firstName }} {{
                    userDetails.lastName }}</span>
                </div>
                <dsr-icon name="arrow-down-2" size="1.6rem" color="black"
                  class="absolute right-[2rem] transition-transform duration-300"
                  [ngClass]="{ 'rotate-180': isUserSubMenuOpen }"></dsr-icon>
              </div>

              <!-- User menu panel (déroulant) -->
              @if(isUserSubMenuOpen) {
                <div class="flex flex-col gap-[1.6rem] pl-[3.6rem] items-center pt-[1.6rem] focus:bg-light-dsr-color-on-secondary-container">
                  @for (item of menuItemLabels; track item; let i = $index) {
                    <a (click)="closeMobileMenu()" [routerLink]="routeLinks[i]"
                      class="flex items-center gap-[1.2rem] py-[1.2rem]">
                      <dsr-icon [name]="menuItemIcons[i]" size="2.4rem" color="black"></dsr-icon>
                      <span class="dsr-typescale-body-medium">{{
                        item | translate
                        }}</span>
                    </a>
                  }
                </div>
              }
            </div>
          }
          <!-- mobile user menu  -->
        </div>
        @if(isAuthenticated()) {
          <div class="px-[2rem] py-[1.6rem] border-t border-gray-100">
            <div
              class="flex items-center gap-[1.2rem] w-fit justify-self-center dsr-typescale-label-medium font-renault-group-semi-bold py-[1.2rem]"
              (click)="logout()">
              <dsr-icon name="exit" size="2.4rem" color="black"></dsr-icon>
              <span>{{ "HEADER_LIST_LOGOUT" | translate }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>

</div>
